export const VARIABLE_CONDITION_OPERATORS = {
    string: [
        { value: 'equals', label: 'equals' },
        { value: 'not-equals', label: 'not equals' },
        { value: 'contains', label: 'contains' },
        { value: 'not-contains', label: 'not contains' },
        { value: 'greater-than', label: 'is greater than' },
        { value: 'less-than', label: 'is less than' },
        { value: 'greater-than-or-equal', label: 'is greater than or equal to' },
        { value: 'less-than-or-equal', label: 'is less than or equal to' },
        { value: 'any-of', label: 'is any of' },
        { value: 'none-of', label: 'is none of' },
        { value: 'exists', label: 'exists' },
        { value: 'not-exists', label: 'does not exist' }
    ],
    number: [
        { value: 'equals', label: '=' },
        { value: 'not-equals', label: '!=' },
        { value: 'greater-than', label: '>' },
        { value: 'less-than', label: '<' },
        { value: 'greater-than-or-equal', label: '>=' },
        { value: 'less-than-or-equal', label: '<=' },
        { value: 'exists', label: 'exists' },
        { value: 'not-exists', label: 'does not exist' }
    ],
    boolean: [
        { value: 'equals', label: 'equals' },
        { value: 'not-equals', label: 'not equals' },
        { value: 'exists', label: 'exists' },
        { value: 'not-exists', label: 'does not exist' }
    ],
    array: [
        { value: 'contains', label: 'contains' },
        { value: 'not-contains', label: 'not contains' },
        { value: 'exists', label: 'exists' },
        { value: 'not-exists', label: 'does not exist' }
    ]
};
/** Each operation as a sentence reads it, such as "Status does not equal active". */
export const VARIABLE_CONDITION_OPERATION_LABELS = {
    equals: 'equals',
    'not-equals': 'does not equal',
    contains: 'contains',
    'not-contains': 'does not contain',
    'any-of': 'is any of',
    'none-of': 'is none of',
    'greater-than': 'is greater than',
    'less-than': 'is less than',
    'greater-than-or-equal': 'is greater than or equal to',
    'less-than-or-equal': 'is less than or equal to',
    exists: 'exists',
    'not-exists': 'does not exist'
};
export const getConditionOperators = (type) => VARIABLE_CONDITION_OPERATORS[type].map((o) => o.value);
//# sourceMappingURL=variable-condition-operators.js.map